<input
  [id]="id"
  type="checkbox"
  class="size-[16px] cursor-pointer rounded-[3px] border-aux-gray-dark text-aux-blue focus:ring-aux-blue"
  [ngClass]="{ 'cursor-not-allowed bg-gray-100': disabled }"
  [checked]="fc.value"
  [disabled]="disabled"
  (change)="onCheckboxChange($event)"
  auxFormError
  [indeterminate]="indeterminate"
/>
<label class="ml-1.5 block cursor-pointer" [for]="id"><ng-content></ng-content></label>
